import React from "react";
import { useSelector } from "react-redux";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export const Loading = () => {
  const loading = useSelector(state => state.app.loading);
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: 1301 }}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  )
}
